export default {
    title: 'Neue Organisation anlegen',
    name: 'Name',
    email: 'E-Mail',
    createOrganisation: 'Neue Organisation anlegen',
    createAndEditOrganisation: 'Erstellen und weiter bearbeiten',
    createOrganisationSuccess: 'Die Organisation wurde erfolgreich erstellt.',
    createOrganisationError: 'Die Organisation konnte nicht erstellt werden.',
}